import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { switchMap } from 'rxjs';

import { ChurnFlowAnalyticsBaseService, ChurnFlowDataBaseService } from '@core/churn-flow-logic';
import { ChurnReason } from '@core/churn-flow-types';
import { ChurnFlowStepTemplateComponent } from '@core/churn-flow-ui';
import { filterDefined } from '@core/common-legacy';
import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  ButtonLoadingDirective,
  CheckboxComponent,
  IconComponent,
  NotificationsController,
} from '@core/user-interface-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';

@Component({
  selector: 'tlc-churn-flow-subscription-loss-page',
  templateUrl: './churn-flow-subscription-loss-page.component.html',
  styleUrls: ['./churn-flow-subscription-loss-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChurnFlowInsightsComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
    CheckboxComponent,
    ButtonComponent,
    ButtonLoadingDirective,
  ],
})
export class ChurnFlowSubscriptionLossPageComponent {
  private readonly t = injectTranslate();
  private readonly router = inject(Router);
  private readonly churnFlowDataService = inject(ChurnFlowDataBaseService);
  private readonly notificationController = inject(NotificationsController);
  private readonly analytics = inject(ChurnFlowAnalyticsBaseService);
  private readonly untilDestroyed = injectUntilDestroyed();

  protected readonly careersSiteUrl = this.churnFlowDataService.careersSiteUrl;

  public consentChecked = signal<boolean>(false);
  public submitting = signal<boolean>(false);

  public toggleConsent(value: any): void {
    this.consentChecked.set(value);
  }

  public stayWithTellent(): void {
    this.analytics.trackStayWithTellent({ step: 'step-4' });
    this.router.navigate([{ outlets: { dialog: null, primary: ['billing'] } }]);
  }

  public cancelSubscription(): void {
    this.churnFlowDataService.lockedChurnReason
      .pipe(
        filterDefined,
        switchMap((reason: ChurnReason) => {
          this.analytics.trackStepFourContinue({ reason });
          return this.churnFlowDataService.cancelSubscription();
        }),
        this.untilDestroyed,
      )
      .subscribe(({ success }) => {
        if (success) {
          this.router.navigate([{ outlets: { dialog: ['churn', 'farewell'] } }]);
        } else {
          this.submitting.set(false);
          this.consentChecked.set(false);
          this.notificationController.error(this.t('tlc.churn_flow.common.something_went_wrong'));
        }
      });
  }
}
